<script>
import SubscriptionHeader from "./Header";
import Cycles from "./Cycles/Index";
import timeMixin from "@/mixins/timeMixin.js";

export default {
  mixins: [timeMixin],
  props: {
    subscription: {
      type: Object,
      required: true
    }
  },
  components: {
    SubscriptionHeader,
    Cycles
  }
};
</script>

<template>
  <div class="card">
    <subscription-header :subscription="subscription" />
    <hr />
    <cycles :cycles="subscription.cycles" />
  </div>
</template>

<style scoped>
hr {
  border: 1px solid #eee;
  background: none;
  margin: 10px 0;
}

.card {
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Subscriptions/Subscription/Index.vue